module.exports = __webpack_public_path__ + "img/icon-help.18b940a1.svg";